import React from "react"
import { ResponsivePie } from '@nivo/pie'
import BaseChart from "../baseChart/BaseChart"
import { Container } from "./Styled"

type PieProps = {
    title: string;
    data?: any;
}

const Pie: React.FunctionComponent<PieProps> = ({
    title,
    data
}) => {
    return (
        <Container>
            <BaseChart title={title}>
                <ResponsivePie
                    data={data}
                    margin={{ top: 40, right: 80, bottom: 80, left: 70 }}
                    innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    borderWidth={1}
                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                    enableRadialLabels={false}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: 'rgba(255, 255, 255, 0.3)',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}

                    legends={[
                        {
                            anchor: 'top-right',
                            direction: 'column',
                            justify: false,
                            translateX: 75,
                            translateY: 56,
                            itemsSpacing: 30,
                            itemWidth: 10,
                            itemHeight: 0,
                            itemTextColor: '#999',
                            itemDirection: 'right-to-left',
                            itemOpacity: 1,
                            symbolSize: 18,
                            symbolShape: 'circle',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemTextColor: '#000'
                                    }
                                }
                            ]
                        }
                    ]}
                />
            </BaseChart>
        </Container>
    )
}

export default Pie